import { Measure } from '../types/measure';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';

export class MeasureService {
  private collectionName = '8am-measure';

  async getAllMeasures(): Promise<Measure[]> {
    try {
      const querySnapshot = await getDocs(collection(db, this.collectionName));
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as Measure));
    } catch (error) {
      console.error('Error getting measures:', error);
      throw error;
    }
  }

  async getActiveMeasures(): Promise<Measure[]> {
    try {
      const q = query(
        collection(db, this.collectionName),
        where('isActive', '==', true)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      } as Measure));
    } catch (error) {
      console.error('Error getting active measures:', error);
      throw error;
    }
  }

  async addMeasure(measure: Measure): Promise<string> {
    try {
      const docRef = await addDoc(collection(db, this.collectionName), {
        ...measure,
        isActive: true
      });
      return docRef.id;
    } catch (error) {
      console.error('Error adding measure:', error);
      throw error;
    }
  }

  async updateMeasure(id: string, measure: Partial<Measure>): Promise<void> {
    try {
      const measureRef = doc(db, this.collectionName, id);
      await updateDoc(measureRef, measure);
    } catch (error) {
      console.error('Error updating measure:', error);
      throw error;
    }
  }

  async deleteMeasure(id: string): Promise<void> {
    try {
      await deleteDoc(doc(db, this.collectionName, id));
    } catch (error) {
      console.error('Error deleting measure:', error);
      throw error;
    }
  }

  async deactivateMeasure(id: string): Promise<void> {
    try {
      const measureRef = doc(db, this.collectionName, id);
      await updateDoc(measureRef, { isActive: false });
    } catch (error) {
      console.error('Error deactivating measure:', error);
      throw error;
    }
  }
} 